
class CreateTherapistEmployeeTypeReq {

     
    constructor(){
        this.Id = undefined;
        this.TypeName = undefined;
        this.StandardHourlyRate = undefined
        this.pagingParams = {
            pageNumber : undefined,
            pageSize : undefined
        };

    }
}

export default CreateTherapistEmployeeTypeReq;